import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Typography,
    CircularProgress
} from '@mui/material';

import * as PolnApi from "../../utils/api-service";

export default function SettingsDialog({ open, onClose, onSave, user }) {
    const [affiliateTag, setAffiliateTag] = useState('');
    const [saveLoading, setSaveLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSave = () => {
        if (!affiliateTag.trim()) {
            setError('Affiliate Tag ID is required');
            return;
        }
        onSave({ affiliateTagId: affiliateTag }, setSaveLoading);
        setAffiliateTag(affiliateTag);
        setError('');
        onClose(null, () => {
            setSaveLoading(false);
        });
    };

    const handleClose = () => {
        setAffiliateTag('');
        setError('');
        onClose(null, () => {
            setSaveLoading(false);
        });
    };

    // let's fetch the settings
    useEffect(() => {
        const fetchSettings = async () => {
            const res = await PolnApi.request('/creator/settings');
            if (res?.statusCode === 200) {
                setAffiliateTag(res?.body?.settings?.affiliateTagId || '');
            }
        }

        if (user) {
            fetchSettings();
        }
    }, [user]);

    return (
        <Dialog 
            open={open} 
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    bgcolor: '#fff'
                }
            }}
        >
            <DialogTitle>
                <Typography variant="h6" fontWeight={700} color="#181A2A">
                    Settings
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <TextField
                        fullWidth
                        label="Affiliate Tag ID"
                        value={affiliateTag}
                        onChange={(e) => {
                            setAffiliateTag(e.target.value);
                            setError('');
                        }}
                        error={!!error}
                        helperText={error}
                        variant="outlined"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: '#5B5BF6',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#5B5BF6',
                                }
                            }
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button 
                    onClick={handleClose}
                    sx={{
                        color: '#181A2A',
                        '&:hover': {
                            bgcolor: 'rgba(27, 26, 42, 0.04)'
                        }
                    }}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleSave}
                    variant="contained"
                    disabled={!affiliateTag.trim()}
                    sx={{
                        bgcolor: '#5B5BF6',
                        color: '#fff',
                        '&:hover': {
                            bgcolor: '#4949C4'
                        },
                        '&.Mui-disabled': {
                            bgcolor: '#BFC8E6',
                            color: '#fff'
                        }
                    }}
                >
                    {saveLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
} 